(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("partial-layer", [], factory);
	else if(typeof exports === 'object')
		exports["partial-layer"] = factory();
	else
		root["partial-layer"] = factory();
})(self, function() {
return 